import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { Link } from 'react-router-dom';
import { Page, BlockStack, DataTable, Text, Button } from '@shopify/polaris';
import { useAppBridge } from '@shopify/app-bridge-react';
import {
  PlusIcon,
  DeleteIcon
} from '@shopify/polaris-icons';

import PageFooter from '../partials/PageFooter';
import LoadingPlaceholder from '../partials/LoadingPlaceholder';
import RequiresRefreshBanner from '../partials/RequiresRefreshBanner';

import DeleteDialog from './DeleteDialog';

import { indexBarcodeTemplates, deleteBarcodeTemplate } from '../../redux/actions/barcodeTemplates';

const BarcodeTemplates = ({ shopUrl, payload, barcodeTemplates, getTemplates, deleteTemplate, requiresRefresh }) => {
  const [activeUuid, setActiveUuid] = useState(false);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    getTemplates(shopUrl, payload);
  }, []);

  useEffect(() => {
    let rows = [];

    barcodeTemplates.templates.map((template) => 
      rows.push([
        <Link
          to={`edit/${template.uuid}${window.location.search}`}
        >
          {template.template_name}
        </Link>,
        <ul>
          <li>Size: {template.width || 3}{template.size_measurement} x {template.length || 1}{template.size_measurement}</li>
          <li>Rotate: {template.rotate && "Rotated"}{!template.rotate && "Not rotated"}</li>
        </ul>,
        <Button icon={DeleteIcon} variant="primary" tone="critical" onClick={() => deleteDialog(template.uuid)}>Delete</Button>
      ])
    );

    setRows(rows);
  }, [barcodeTemplates.templates]);

  const deleteDialog = (uuid) => {
    setActiveUuid(uuid);
    shopify.modal.show('delete-modal');
  }

  const removeTemplate = (uuid) => {
    deleteTemplate(shopUrl, payload, uuid);
    shopify.modal.hide('delete-modal');
    // getTemplates(shopUrl, payload);
  }

  const shopify = useAppBridge();

  return(
    <>
      <Page 
        title="Label Templates"
        primaryAction={<Link to={`/templates/new${window.location.search}`}><Button icon={PlusIcon} variant="primary">New Template</Button></Link>}
        backAction={{content: 'Back', url: 'https://' + window.location.hostname + window.location.search}}
      >
        { requiresRefresh &&
          <RequiresRefreshBanner />
        }
        { barcodeTemplates.status === 'success' && !barcodeTemplates.isFetching && !barcodeTemplates.isDeleting &&
          <>
            <BlockStack gap="500">
              <DataTable
                columnContentTypes={[
                  'text',
                  'text',
                  'text'
                ]}
                headings={['Template Name', 'Template Options', 'Actions']}
                rows={rows}
              />

              <PageFooter stripeBackground='#5bc6cc' helpLink="shopify/manage-barcode-label-templates-3/" helpDescription="setting up label templates" />
            </BlockStack>

          </>
        }

        { (barcodeTemplates.status !== 'success' || barcodeTemplates.isFetching || barcodeTemplates.isDeleting) &&
          <>
            <LoadingPlaceholder />
          </>
        }

      </Page>

      <DeleteDialog
        removeTemplate={removeTemplate}
        shopify={shopify}
        activeUuid={activeUuid}
      />
    </>
  )
}

const mapStateToProps = state => ({
  requiresRefresh: state.activeToken.requiresRefresh,
  barcodeTemplates: state.barcodeTemplates,
});

const mapDispatchToProps = (dispatch) => ({
  getTemplates: (shopUrl, payload) => dispatch(indexBarcodeTemplates(shopUrl, payload)),
  deleteTemplate: (shopUrl, payload, templateId) => dispatch(deleteBarcodeTemplate(shopUrl, payload, templateId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BarcodeTemplates);